<div class="content-wrapper container-xxl p-0 card">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink small-card">
        <div class="card small-card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.users' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Users
            </button> -->
          </div>
          <div class="card-body">
            <!-- <p class="card-text">{{ 'MENU.DASHBOARD.USERS_LIST' | translate }}</p> -->
          </div>

<section id="dashboard-statistics">
  <div class="card small-card">
    <div class="card-body">

      <!-- ONE LINE ROW -->
<div class="row text-center justify-content-center flex-nowrap stats-row">
        <!-- Total Users -->
        <div class="col-auto mb-2">
          <div class="bg-primary text-white rounded p-2 shadow stat-card-fixed">
            <p class="mb-0">{{ "MENU.DASHBOARD.TOTAL_USERS" | translate }}</p>
            <h3 class="fw-bold mt-1">{{ statistics?.total_users }}</h3>
          </div>
        </div>

        <!-- Total Missed Prayers -->
        <div class="col-auto mb-2">
          <div class="rounded p-2 shadow stat-card-fixed" style="background-color:#363640;">
            <p class="mb-0 text-light">{{ "MENU.DASHBOARD.MISSED_PRAYERS" | translate }}</p>
            <h3 class="fw-bold text-white mt-1">{{ statistics?.total_missed_prayers }}</h3>
          </div>
        </div>

        <!-- Missed Today -->
        <div class="col-auto mb-2">
          <div class="rounded p-2 shadow stat-card-fixed" style="background:#9b7e4d;">
            <p class="mb-0 text-white">{{ "MENU.DASHBOARD.TOTAL_ELIMINATION_TODAY" | translate }}</p>
            <h3 class="fw-bold text-white mt-1">{{ statistics?.today_missed_prayers }}</h3>
          </div>
        </div>

        <!-- Today Users -->
        <!-- <div class="col-auto mb-2">
          <div class="stat-card stat-primary rounded p-2 shadow stat-card-fixed" style="background:#2563eb;">
            <p class="mb-0">{{ "MENU.DASHBOARD.NEW_USERS" | translate }}</p>
            <h3 class="fw-bold mt-1">{{ statistics?.today_users }}</h3>
          </div>
        </div> -->

        <!-- Total by Days -->
        <div class="col-auto mb-2">
          <div class="stat-card stat-secondary rounded p-2 shadow stat-card-fixed">
            <p class="mb-0">{{ "MENU.DASHBOARD.TOTAL_ELIMINATION" | translate }}</p>
            <h3 class="fw-bold mt-1">{{ statistics?.total_missed_prayers_by_days }}</h3>
          </div>
        </div>

        <!-- 👇 NEW CARDS -->

        <!-- المستخدمين اليوميون -->
        <!-- <div class="col-auto mb-2">
          <div class="rounded p-2 shadow stat-card-fixed" style="background:#18734f;">
            <p class="mb-0 text-white">المستخدمين اليوميون</p>
            <h3 class="fw-bold text-white mt-1">{{ statistics?.daily_users || 0 }}</h3>
          </div>
        </div> -->

        <!-- مسجلين جدد اليوم -->
        <div class="col-auto mb-2">
          <div class="rounded p-2 shadow stat-card-fixed" style="background:#6b21c8;">
            <p class="mb-0 text-white">{{ "MENU.DASHBOARD.NEW_USERS_TODAY" | translate }}</p>
            <h3 class="fw-bold text-white mt-1">
              {{ statistics?.new_users_today || statistics?.today_users || 0 }}
            </h3>
          </div>
        </div>

        
        <!-- مسجلين جدد هذا الأسبوع -->
        <!-- <div class="col-auto mb-2">
          <div class="rounded p-2 shadow stat-card-fixed" style="background:#198754;">
            <p class="mb-0 text-white">مسجلين جدد هذا الأسبوع</p>
            <h3 class="fw-bold text-white mt-1">{{ statistics?.new_users_this_week || 0 }}</h3>
          </div>
        </div> -->

        <!-- مسجلين جدد هذا الشهر -->
        <!-- <div class="col-auto mb-2">
          <div class="rounded p-2 shadow stat-card-fixed" style="background:#8e24aa;">
            <p class="mb-0 text-white">مسجلين جدد هذا الشهر</p>
            <h3 class="fw-bold text-white mt-1">{{ statistics?.new_users_this_month || 0 }}</h3>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</section>

<style>
  .stats-row {
    gap: 0.25rem;
    flex-wrap: nowrap !important;
    overflow: visible;
  }

  .stats-row .col-auto {
    flex: 1 1 auto;
    min-width: 0;
  }
</style>


        </div>
  
            <div class="row d-flex justify-content-between">
           <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">{{ 'MENU.DASHBOARD.SHOW' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2 text-end"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mr-1">{{ 'MENU.DASHBOARD.ENTRIES' | translate }}</span>
              </div>
            </div>
          </div> 
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="">{{ 'MENU.DASHBOARD.SEARCH' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}"
                class="form-control form-control-sm w-75"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable
          [rows]="arrCoupons" 
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
                      [messages]="{ totalMessage: lang == 'ar' ? 'العدد الكلي' : 'total' }"

        >
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ID' | translate }}"
            prop="id"
            [width]="40"
          ></ngx-datatable-column>
  
          <!-- Name -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'الاسم' : 'Name' }}"
    prop="name"
    [width]="250">
    <ng-template ngx-datatable-cell-template let-row="row">
      <strong>{{ row.name }}</strong>
    </ng-template>
  </ngx-datatable-column>

  <!-- Email -->
  <ngx-datatable-column
    name="{{ lang == 'ar' ? 'البريد الإلكتروني' : 'Email' }}"
    prop="email"
    [width]="330">
  </ngx-datatable-column>


  <!-- Registration Date -->
<ngx-datatable-column
  name="{{ lang === 'ar' ? 'تاريخ التسجيل' : 'Registration Date' }}"
  prop="created_at"
  [width]="220"
>
  <ng-template ngx-datatable-cell-template let-row="row">
    <span class="text-muted">
      {{ row.created_at | date : 'dd MMM yyyy' }}
    </span>
  </ng-template>
</ngx-datatable-column>


  <!-- Country -->
  <!-- <ngx-datatable-column
    name="{{ lang == 'ar' ? 'الدولة' : 'Country' }}"
    prop="country"
    [width]="140">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.country || '-' }}
    </ng-template>
  </ngx-datatable-column> -->

  <!-- City -->
  <!-- <ngx-datatable-column
    name="{{ lang == 'ar' ? 'المدينة' : 'City' }}"
    prop="city"
    [width]="140">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.city || '-' }}
    </ng-template>
  </ngx-datatable-column> -->

  <!-- Notifications Enabled -->
  <!-- <ngx-datatable-column
    name="{{ lang == 'ar' ? 'الإشعارات' : 'Notifications' }}"
    [width]="140">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span
        class="badge"
        [ngClass]="row.notification_enabled ? 'badge-light-success' : 'badge-light-danger'">
        {{
          row.notification_enabled
            ? ('MENU.DASHBOARD.ENABLED' | translate)
            : ('MENU.DASHBOARD.DISABLED' | translate)
        }}
      </span>
    </ng-template>
  </ngx-datatable-column> -->

  <!-- Deleted At -->
  <!-- <ngx-datatable-column
    name="{{ lang == 'ar' ? 'محذوف' : 'Deleted' }}"
    [width]="120">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.deleted_at ? ('MENU.DASHBOARD.YES' | translate) : '-' }}
    </ng-template>
  </ngx-datatable-column> -->

  <!-- Updated At -->
  <!-- <ngx-datatable-column
    name="{{ lang == 'ar' ? 'آخر تحديث' : 'Updated At' }}"
    [width]="150">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.updated_at | date: 'mediumDate' }}
    </ng-template>
  </ngx-datatable-column> -->

   
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [width]="120"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div ngbDropdown container="body">
                <button
                  type="button"
                  class="btn btn-sm hide-arrow"
                  ngbDropdownToggle
                >
                  <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu>

<a
  ngbDropdownItem
  [routerLink]="['/z-users-details', row.id]"
>
  <i  
    data-feather="eye"
    [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"
  ></i>
  <span>{{ "MENU.DASHBOARD.Details" | translate }}</span>
</a>

  <!-- <a
                      ngbDropdownItem
                      (click)="deleteUser(row.id)"
                      class="text-danger"
                    >
                      <i data-feather="x-octagon" [class]="lang == 'ar' ? 'ml-1' : 'mr-1'"></i
                      ><span>{{ "MENU.DASHBOARD.closeAcc" | translate }}</span>
                    </a> -->
                  <!-- <a
                    ngbDropdownItem
                    [routerLink]="['/main/coupons/edit', row.id]"
                  >
                    <i data-feather="edit-2" class="mr-50"></i
                    ><span>{{ "MENU.Edit" | translate }}</span>
                  </a> -->
                  <!-- <a ngbDropdownItem (click)="confirmDelete(row.id)">
                    <i data-feather="trash" class="mr-50"></i
                    ><span>{{ "MENU.Delete" | translate }}</span>
                  </a> -->
                </div>
              </div> 
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable> 
      </section>
    </div>
  </div>
  